import { apiCall } from "../../utils/api";

import { notification } from "../home/action";

import TYPE from "../../constants/type";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";
import select from "utils/select";

export const getAllInternalResearch = () => async (dispatch) => {
  const api = API_URLS.INTERNAL_RESEARCH.getAllInternalResearch();
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.GET_ALL_INTERNAL_RESEARCH_LOADING,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.GET_ALL_INTERNAL_RESEARCH_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.GET_ALL_INTERNAL_RESEARCH_FAILURE,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_FAILURE] },
    });
  }
};

export const insertInternalResearch = (payload) => async (dispatch) => {
  const api = API_URLS.INTERNAL_RESEARCH.insertInternalResearch();
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.INSERT_INTERNAL_RESEARCH_LOADING,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.INSERT_INTERNAL_RESEARCH_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Thêm đề tài thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.INSERT_INTERNAL_RESEARCH_FAILURE,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_FAILURE] },
    });
    // console.log("insertInternalResearch error", error);
    // apiCall đã đổi từ `error: e.request` → `error: e` (full axios error).
    // Raw response text từ XHR vẫn nằm ở error.request.response; message JSON
    // từ BE nằm ở error.response.data.message.
    const rawErr = error?.request?.response || "";
    const serverMsg = error?.response?.data?.message || rawErr;
    if (rawErr.includes("time conflict") || serverMsg.includes("time conflict")) {
      dispatch(
        notification({
          type: "warning",
          message: "Thêm đề tài thất bại! Đề tài bị trùng thời gian với một đề tài khác.",
        })
      );
      return false;
    } else {
      dispatch(
        notification({
          type: "error",
          message: `Thêm đề tài thất bại! ${serverMsg}`,
        })
      );
    }
    return false;
  }
};

export const updateInternalResearchStatus = (id, status) => async (dispatch, getState) => {
  const allInternalResearch = select(getState(), "internalResearchReducer", "list") || [];
  // console.log("allInternalResearch", allInternalResearch, payload);
  const oldInternalResearch = allInternalResearch.find((e) => e.id === id);
  const api = API_URLS.INTERNAL_RESEARCH.updateInternalResearchStatus(id, status, oldInternalResearch?.status);
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_STATUS_LOADING,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_STATUS_SUCCESS,
      id,
      status,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật trạng thái đề tài thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_STATUS_FAILURE,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_FAILURE] },
    });
    if ((error?.request?.response || error?.response?.data?.message || "").includes("wrong old status")) {
      dispatch(
        notification({
          type: "warning",
          message: "Dữ liệu đã thay đổi bởi người khác, vui lòng tải lại trang!",
        })
      );
      return false;
    }
    dispatch(
      notification({
        type: "error",
        message: "Cập nhật trạng thái đề tài thất bại!",
      })
    );
    return false;
  }
};

export const updateInternalResearch = (payload) => async (dispatch, getState) => {
  // get all internal research from state to check time conflict
  const allInternalResearch = select(getState(), "internalResearchReducer", "list") || [];
  // console.log("allInternalResearch", allInternalResearch, payload);
  const oldInternalResearch = allInternalResearch.find((e) => e.id === payload.id);
  payload.oldStatus = oldInternalResearch?.status;
  const api = API_URLS.INTERNAL_RESEARCH.updateInternalResearch(payload);
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_LOADING,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_SUCCESS,
      payload,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật đề tài thành công!",
      })
    );
    return true;
  } else {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_FAILURE,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_FAILURE] },
    });
    if ((error?.request?.response || error?.response?.data?.message || "").includes("wrong old status")) {
      dispatch(
        notification({
          type: "warning",
          message: "Dữ liệu đã thay đổi bởi người khác, vui lòng tải lại trang!",
        })
      );
      return false;
    }
    dispatch(
      notification({
        type: "error",
        message: "Cập nhật đề tài thất bại!",
      })
    );
    return false;
  }
};

export const deleteInternalResearch = (id) => async (dispatch) => {
  const api = API_URLS.INTERNAL_RESEARCH.deleteInternalResearch(id);
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.DELETE_INTERNAL_RESEARCH_LOADING,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.DELETE_INTERNAL_RESEARCH_SUCCESS,
      id,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.DELETE_INTERNAL_RESEARCH_FAILURE,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_FAILURE] },
    });
  }
};

export const filterInternalResearch = (payload) => async (dispatch) => {
  const api = API_URLS.INTERNAL_RESEARCH.filterInternalResearch(payload);
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.FILTER_INTERNAL_RESEARCH_LOADING,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.FILTER_INTERNAL_RESEARCH_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.FILTER_INTERNAL_RESEARCH_FAILURE,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_FAILURE] },
    });
  }
};

export const filterInternalResearchV2 = (payload) => async (dispatch) => {
  const api = API_URLS.INTERNAL_RESEARCH.filterInternalResearchV2(payload);
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.FILTER_INTERNAL_RESEARCH_LOADING,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.FILTER_INTERNAL_RESEARCH_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.FILTER_INTERNAL_RESEARCH_FAILURE,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_FAILURE] },
    });
  }
};

// ===========================================================================
// Refactor 2026-05-15: 17 action-based dispatchers cho state machine mới.
// Pattern giống đề tài SV (reducer/studentResearch/action.js):
//   - runAction: dispatch LOADING/SUCCESS/FAILURE chung +
//     gọi notification + refresh entity sau success.
//   - refreshInternalResearch: fetch entity by id, dispatch UPDATE_SUCCESS để
//     đồng bộ list / row UI (nhiều endpoint BE trả `ok(w,r,nil)` không kèm data).
// ===========================================================================

const notify = (dispatch, type, message) =>
  dispatch(notification({ type, message }));

const refreshInternalResearch = async (dispatch, id) => {
  try {
    const api = API_URLS.INTERNAL_RESEARCH.getInternalResearchById(id);
    const res = await apiCall({ ...api });
    if (!res.error && res.response?.status === 200 && res.response.data.success) {
      dispatch({
        type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_SUCCESS,
        payload: res.response.data.data,
        meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
      });
    }
  } catch (e) {
    // Nuốt lỗi refresh — action chính đã OK.
  }
};

const runAction = async (
  dispatch,
  { api, payload, successMessage, errorMessage, extras = {} }
) => {
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_LOADING,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response?.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_SUCCESS,
      payload: response.data.data,
      ...extras,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
    });
    if (successMessage) notify(dispatch, "success", successMessage);
    if (extras?.id) await refreshInternalResearch(dispatch, extras.id);
    return true;
  }
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.UPDATE_INTERNAL_RESEARCH_FAILURE,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_FAILURE] },
  });
  if (errorMessage) {
    const serverMsg = error?.response?.data?.message || response?.data?.message;
    notify(dispatch, "error", `${errorMessage}${serverMsg ? ` ${serverMsg}` : ""}`);
  }
  return false;
};

// ---- Registration ----
// Refactor 2026-05-16: dùng `insertInternalResearch` endpoint (POST /create)
// thay vì /registration. chi v1.5.4 conflict literal vs `/{id}` ở root level
// gây 405; BE đã merge default lifecycle init vào CreateInternalResearch.

export const createRegistration = (payload) => async (dispatch) => {
  const api = API_URLS.INTERNAL_RESEARCH.insertInternalResearch();
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.INSERT_INTERNAL_RESEARCH_LOADING,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response?.status === 200 && response.data.success) {
    const entity = response.data.data;
    dispatch({
      type: TYPE.INTERNAL_RESEARCH.INSERT_INTERNAL_RESEARCH_SUCCESS,
      payload: entity,
      meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_SUCCESS] },
    });
    notify(dispatch, "success", "Tạo nháp đăng ký thành công!");
    return entity;
  }
  dispatch({
    type: TYPE.INTERNAL_RESEARCH.INSERT_INTERNAL_RESEARCH_FAILURE,
    meta: { prefix: [PREFIX.INTERNAL_RESEARCH, PREFIX.API_FAILURE] },
  });
  const serverMsg = error?.response?.data?.message || response?.data?.message;
  notify(dispatch, "error", `Tạo nháp thất bại! ${serverMsg || ""}`);
  return null;
};

export const submitRegistrationInternal = (id) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.submitRegistration(id),
    successMessage: "Đã nộp đăng ký!",
    errorMessage: "Nộp đăng ký thất bại!",
    extras: { id },
  });

export const reviewByMod = (id, action, comment) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.reviewByMod(id),
    payload: { action, comment },
    successMessage: "Đã cập nhật kết quả duyệt vòng đơn vị!",
    errorMessage: "Duyệt vòng đơn vị thất bại!",
    extras: { id },
  });

// reviewByAdmin — payload thêm `researchCode` để Phòng QLKH gán/sửa mã đề tài
// lúc accept. Bỏ trống → BE auto-gen `ĐTCS_<khoa>_{yy}.{seq}`.
export const reviewByAdmin = (id, action, comment, researchCode = "") => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.reviewByAdmin(id),
    payload: { action, comment, researchCode },
    successMessage: "Đã cập nhật kết quả duyệt vòng Phòng QLKH!",
    errorMessage: "Duyệt vòng Phòng QLKH thất bại!",
    extras: { id },
  });

// suggestResearchCode — gọi BE trả về mã ĐTCS_<khoa>_{yy}.{seq:02d} tiếp theo.
// yy lấy theo năm **kết thúc** đề tài (endYear), seq đếm riêng theo từng khoa.
// Promise<string>, lỗi → "".
export const suggestResearchCode = async (schoolYear, departmentId, endYear) => {
  try {
    const api = API_URLS.INTERNAL_RESEARCH.suggestResearchCode(
      schoolYear,
      departmentId,
      endYear
    );
    const { response, error } = await apiCall({ ...api });
    if (!error && response?.status === 200 && response.data.success) {
      return response.data.data?.suggestedCode || "";
    }
  } catch (e) {
    // ignore
  }
  return "";
};

// getCouncilHistory — các lần hội đồng trước đó (đã bị thay thế) của 1 loại
// hội đồng (selection|midterm|final). Promise<Array>, lỗi → [].
export const getCouncilHistory = async (internalResearchId, councilType) => {
  try {
    const api = API_URLS.INTERNAL_RESEARCH.getCouncilHistory(internalResearchId, councilType);
    const { response, error } = await apiCall({ ...api });
    if (!error && response?.status === 200 && response.data.success) {
      return response.data.data || [];
    }
  } catch (e) {
    // ignore
  }
  return [];
};

// ---- Hội đồng (3 vòng) ----
// Payload council: { councilTemplateId?, members:[{roleKey, orderNum, profileId, name, degree, isPhenikaa}] }

export const createSelectionCouncil = (id, council) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.createSelectionCouncil(id),
    payload: council,
    successMessage: "Đã gán Hội đồng tuyển chọn!",
    errorMessage: "Gán Hội đồng tuyển chọn thất bại!",
    extras: { id },
  });

// Payload review: { action, comment, minutesFileLink, evaluationFileLink }
export const reviewSelectionCouncil = (id, payload) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.reviewSelectionCouncil(id),
    payload,
    successMessage: "Đã cập nhật kết quả HĐ tuyển chọn!",
    errorMessage: "Cập nhật HĐ tuyển chọn thất bại!",
    extras: { id },
  });

export const createMidtermCouncil = (id, council) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.createMidtermCouncil(id),
    payload: council,
    successMessage: "Đã gán Hội đồng tiến độ!",
    errorMessage: "Gán Hội đồng tiến độ thất bại!",
    extras: { id },
  });

export const reviewMidtermCouncil = (id, payload) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.reviewMidtermCouncil(id),
    payload,
    successMessage: "Đã cập nhật kết quả HĐ tiến độ!",
    errorMessage: "Cập nhật HĐ tiến độ thất bại!",
    extras: { id },
  });

export const createFinalCouncil = (id, council) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.createFinalCouncil(id),
    payload: council,
    successMessage: "Đã gán Hội đồng nghiệm thu!",
    errorMessage: "Gán Hội đồng nghiệm thu thất bại!",
    extras: { id },
  });

export const reviewFinalCouncil = (id, payload) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.reviewFinalCouncil(id),
    payload,
    successMessage: "Đã cập nhật kết quả HĐ nghiệm thu!",
    errorMessage: "Cập nhật HĐ nghiệm thu thất bại!",
    extras: { id },
  });

// ---- Báo cáo ----
// Payload BCTĐ: { completedWork, evaluation, nextPlan, recommendation, fileLink? }
export const submitProgressReportInternal = (id, payload) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.submitProgressReport(id),
    payload,
    successMessage: "Đã nộp Báo cáo tiến độ!",
    errorMessage: "Nộp Báo cáo tiến độ thất bại!",
    extras: { id },
  });

export const submitFinalReportInternal = (id, fileLink) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.submitFinalReport(id),
    payload: { fileLink },
    successMessage: "Đã nộp Báo cáo tổng kết!",
    errorMessage: "Nộp Báo cáo tổng kết thất bại!",
    extras: { id },
  });

// ---- Xin dừng ----

export const requestStopInternal = (id, reason, fileLink) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.requestStopInternal(id),
    payload: { reason, fileLink },
    successMessage: "Đã gửi đơn xin dừng!",
    errorMessage: "Gửi đơn xin dừng thất bại!",
    extras: { id },
  });

export const reviewStopInternal = (id, action, comment) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.reviewStopInternal(id),
    payload: { action, comment },
    successMessage: "Đã cập nhật kết quả duyệt đơn dừng!",
    errorMessage: "Duyệt đơn dừng thất bại!",
    extras: { id },
  });

// ---- Gia hạn (chỉ 1y) ----

export const requestExtension = (id, reason, fileLink) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.requestExtension(id),
    payload: { reason, fileLink },
    successMessage: "Đã gửi đơn xin gia hạn!",
    errorMessage: "Gửi đơn xin gia hạn thất bại!",
    extras: { id },
  });

export const reviewExtension = (id, action, comment) => (dispatch) =>
  runAction(dispatch, {
    api: API_URLS.INTERNAL_RESEARCH.reviewExtension(id),
    payload: { action, comment },
    successMessage: "Đã cập nhật kết quả duyệt đơn gia hạn!",
    errorMessage: "Duyệt đơn gia hạn thất bại!",
    extras: { id },
  });

